import { sendGoogleEvent } from '@html/_common/utils';
import TourWishlist from '@app/_common/tour-wishlist/wishlist';

const SELECTOR_WISHLIST = '.js-ao-common-tours-slider-card__wishlist';
const SELECTOR_SLIDER_SECTION = '.js-ao-clp-tours';
const SELECTOR_MAIN_TITLE = '.js-ao-clp-tours-slider__title--recently-viewed';
const SELECTOR_CARD_LINK = '.js-ao-common-tours-slider-card__anchor';
const EVENT_CATEGORY = 'CLP - Recently Viewed Tours';
const heartSelector = '.js-ao-common-tours-slider-card__wishlist';
const heartActiveClass = 'ao-common-tours-slider-card__wishlist--active';
const tooltipSelector = '.js-wishlist-icon__tooltip';

export default function AOClpRecentlyViewedTours() {
  let $toursSliderSection;
  let isWishlistEnabled;
  let mainTitleText;

  const initTourWishlist = () => {
    const getTitle = ($element) => $element
      .parent()
      .find('.ao-common-tours-slider-card__title')
      .text()
      ?.trim();

    const googleEventData = {
      category: EVENT_CATEGORY,
      label: mainTitleText,
    };
    const containerSelector = $toursSliderSection;

    TourWishlist({
      googleEventData,
      containerSelector,
      getTitle,
      heartSelector,
      heartActiveClass,
      tooltipSelector,
      getIndex: ($element) => {
        const $associatedCard = $element.parents('.js-ao-clp-carousel-slider__column');
        return $associatedCard && ($associatedCard.index() + 1);
      },
    });
  };

  const cardTracking = () => {
    $toursSliderSection.on('click', SELECTOR_CARD_LINK, (event) => {
      const $target = $(event.currentTarget);
      const targetLink = $target.length && $target.attr('href');
      const targetPosition = $target.length && $target.closest('li').index();

      if (!targetLink) return;

      sendGoogleEvent(
        EVENT_CATEGORY,
        targetLink,
        mainTitleText,
        { eventValue: targetPosition + 1 },
      );
    });
  };

  const initiate = () => {
    $toursSliderSection = $(SELECTOR_SLIDER_SECTION);

    const $mainTitle = $toursSliderSection.find(SELECTOR_MAIN_TITLE);
    mainTitleText = $mainTitle.length ? $mainTitle.text().trim() : 'No title';

    isWishlistEnabled = !!$toursSliderSection.find(SELECTOR_WISHLIST).length;
    cardTracking();

    if (isWishlistEnabled) initTourWishlist();
  };

  return { initiate };
}
